import { atom, atomWithStorage } from '@exodus/headless-ui';
import configAtom from './config.js';
export const toAssetNameAtom = atomWithStorage('exchange.toAssetName');
export const toAssetNameWithConfigAtom = atom((get) => get(toAssetNameAtom) || get(configAtom).defaultToAsset || 'ethereum');
